<script lang="ts" setup>
  /**
   * CURRENT STATUS OF SPA HIJACK BETWEEN FRONTEND AND BACKEND
   *
   * At the moment, SPA hijack (only available in the Marketplace app) is using `next` field to determine the next route to redirect users.
   * It removes complexity between frontend, backend and infrastructure - aka devops, keeping this mechanism fully manageable and documented via app code.
   *
   */
  import Button from '@leaflink/stash/Button.vue';
  import { storeToRefs } from 'pinia';
  import { ref } from 'vue';

  import { CSRF_COOKIE_NAME } from '@/constants';
  import { useAppConfigStore } from '@/piniaStores/appConfig/appConfig.store';
  import { useUserStore } from '@/piniaStores/user/user.store';
  import getCookie from '@/utils/getCookie';

  const { user } = storeToRefs(useUserStore());

  const envName = ref((useAppConfigStore().buildInfo?.envName || 'dev').toLowerCase());
  const csrfToken = ref<string | undefined>(getCookie(CSRF_COOKIE_NAME));
</script>

<template>
  <div :class="['ll-pa-2', $style.hijack, $style[`hijack-${envName}`]]" role="alert">
    <form action="/hijack/release/" method="POST">
      <input type="hidden" name="next" data-test="hijack-release-next" value="/dashboard-redirect/" />
      <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken" />
      <Button type="submit"> Release {{ user.username }} </Button>
      <span class="inline-block ll-ml-2"> ⚠️ Hijack only works in Marketplace. It will not carry to Payments. ⚠️ </span>
    </form>
  </div>
</template>

<style lang="scss" module>
  .hijack {
    background-image: linear-gradient(
      -135deg,
      rgb(0 0 0 / 4%) 25%,
      transparent 25%,
      transparent 50%,
      rgb(0 0 0 / 4%) 50%,
      rgb(0 0 0 / 4%) 75%,
      transparent 75%,
      transparent
    );
    background-repeat: repeat;
    background-size: 75px 75px;
  }

  .hijack-qa {
    background-color: #a6e6fc;
  }

  .hijack-staging {
    background-color: #ffe77f;
  }

  .hijack-prod {
    background-color: #f74a4a;
  }
</style>
